import { useContext, useEffect, useMemo, useState } from 'react'
import { serviceIDs } from 'utils/constants/services'
import useNavigate from 'utils/navigation/useCustomNavigate'
import { AppContext } from '../../../providers/context/App'
import { ErrorContext } from '../../../providers/context/Error'
import { getUserAppointments, getUserInfo } from '../../../services/User'
import { HEALTH_CHECK } from '../../../utils/constants/Enums'
import {
  APPOINTMENT_CONFIRMATION_ROUTE,
  ESTHETICIAN_LIST_ROUTE,
  FACIALS_ROUTE,
  LASER_APPOINTMENT_CONFIRMATION_ROUTE,
  LASER_ESTHETICIAN_LIST_ROUTE,
  LOCATIONS_ROUTE,
} from '../../../utils/constants/Helpers'
import { HeaderTheme } from '../../../utils/types/appTypes'
import CommonHeader from '../../components/common-header'
import HealthCheckContent from '../../components/health-check/health-check-content'
import HealthCheckFooter from '../../components/health-check/health-check-footer'
import LocationFacialBar from '../../components/location-facial-bar'

const HealthCheck = () => {
  const [healthCheck, setHealthCheck] = useState<HEALTH_CHECK>(
    HEALTH_CHECK.NULL
  )
  const { navigate } = useNavigate()
  const { appMasterData, updateData } = useContext(AppContext)
  const { updateErrorData } = useContext(ErrorContext)

  const fetchUserInfo = async () => {
    try {
      const response = await getUserInfo()
      const userAppointment = await getUserAppointments()
      updateData({ previousBookedAppointments: userAppointment })
      return { success: true, data: response }
    } catch (error: any) {
      updateErrorData(error)
      return { success: false }
    }
  }

  useEffect(() => {
    ;(async () => {
      let res = !!appMasterData?.user?.token && (await fetchUserInfo())
      if (res && res.success) {
        updateData({ userInfo: res.data })
      }
    })()

    if (!appMasterData.location.locationId) {
      navigate(LOCATIONS_ROUTE)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const isMicroNeedling = appMasterData.isMicroNeedling
  const isFullEditFacial = useMemo(
    () => serviceIDs?.[6] === appMasterData?.category?.categoryId,
    [appMasterData?.category?.categoryId]
  )

  const backToFunction = () => {
    navigate(
      appMasterData.isLaserFacial
        ? LASER_ESTHETICIAN_LIST_ROUTE
        : ESTHETICIAN_LIST_ROUTE
    )
  }

  const navigateToAppointment = () => {
    navigate(
      appMasterData.isLaserFacial
        ? LASER_APPOINTMENT_CONFIRMATION_ROUTE
        : APPOINTMENT_CONFIRMATION_ROUTE
    )
  }

  const navigateToDateSelection = () => {
    if (isMicroNeedling || isFullEditFacial) {
      return navigate(FACIALS_ROUTE)
    }
    navigate(
      appMasterData.isLaserFacial
        ? LASER_ESTHETICIAN_LIST_ROUTE
        : ESTHETICIAN_LIST_ROUTE
    )
  }

  return (
    <>
      <CommonHeader
        backToFunction={backToFunction}
        theme={HeaderTheme.ORANGE}
      />
      <div className="content-body tertiary-background health-body-wrapper">
        <LocationFacialBar showServiceName={true} />
        <HealthCheckContent healthCheck={healthCheck} />
      </div>
      <HealthCheckFooter
        healthCheck={healthCheck}
        isMicroNeedling={isMicroNeedling}
        setHealthCheck={setHealthCheck}
        navigateToAppointment={navigateToAppointment}
        navigateToDateSelection={navigateToDateSelection}
      />
    </>
  )
}

export default HealthCheck
